import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { TransportManagementDefaultProfileState } from './transport-management-default-profile.state';
import {
  TransportManagementDefaultProfileAffectedUsersLoad,
  TransportManagementDefaultProfileInitialState,
  TransportManagementDefaultProfileLoad,
  TransportManagementDefaultProfileSetToggle,
} from './transport-management-default-profile.actions';
import { TransportManagementProfileModel } from '../models';

@Injectable({ providedIn: 'root' })
export class TransportManagementDefaultProfileFacade implements LoadDataFacade, SetInitialStateFacade {
  defaultProfile$: Observable<TransportManagementProfileModel> = this.store.select(
    TransportManagementDefaultProfileState.getDefaultProfile,
  );
  loaded$: Observable<boolean> = this.store.select(TransportManagementDefaultProfileState.getLoaded);
  affectedUsers$: Observable<number> = this.store.select(TransportManagementDefaultProfileState.getAffectedUsers);

  isEmptyActiveFilter = true;

  constructor(private store: Store) {}

  loadAll(): void {
    this.store.dispatch(new TransportManagementDefaultProfileLoad());
  }

  setDefaultProfileToggle(profileId: number, isDefault: boolean): void {
    this.store.dispatch(new TransportManagementDefaultProfileSetToggle({ profileId, isDefault }));
  }

  getDefaultProfile(): void {
    this.store.dispatch(new TransportManagementDefaultProfileLoad());
  }

  getAffectedUsers(profileId: number): void {
    this.store.dispatch(new TransportManagementDefaultProfileAffectedUsersLoad(profileId));
  }

  setInitialState(): void {
    this.store.dispatch(new TransportManagementDefaultProfileInitialState());
  }
}
